import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=44fdb604"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports